import { ITag } from "./ITag";

export interface IClientData {
  Type: EClientData;
  Value: string;
  IsMain: boolean;
}

export enum EClientData {
  ADDRESS = "address",
  CONTACT_PERSON = "contactPerson",
  EMAIL = "email",
  PHONE = "phone",
  NOTE = "note",
  eaddress = "edeliveryAddress",
  epuapaddress = "epuapAddress",
  /** BE: ClientDataType.BankAccount („bankAccount”) — inna nazwa nie przejdzie przez API. */
  bank = "bankAccount",
  regon = "regon",
}

export interface IClient {
  Id: number;
  IsInstitution: boolean;
  Name: string;
  Data: IClientData[];
  Flags: number;
  Address?: string;
  City?: string;
  ZipCode?: string;
  Phone?: string;
  Email?: string;
  Note?: string;
  NIP?: string;
  REGON: any;
  KRS?: string | null;
  CasesCount: number;
  TargetUserId: any;
  IsGlobal: boolean;
  SourceId: any;
  ContactPersons: any[];
  TagIds: string[];
  IsOnline: boolean;
  Tags: ITag[];
}

/** Powód powstania wersji podmiotu (BE: ParticipantVersionChangeKind). */
export enum EParticipantVersionChangeKind {
  Created = 0,
  Changed = 1,
  Initial = 2,
  ImportedFromMagistrat = 3,
}

/**
 * Wersja danych podmiotu (GET /client/versions). Przesyłki utworzone przy danej wersji pokazują
 * jej dane także po późniejszych zmianach podmiotu.
 */
export interface IClientVersion {
  Id: number;
  VersionNo: number;
  ValidFrom: string;
  ValidTo?: string | null;
  IsCurrent: boolean;
  ChangeKind: EParticipantVersionChangeKind;
  CreatedByUserId?: string | null;
  CreatedByName?: string | null;
  IsInstitution: boolean;
  Name?: string | null;
  NIP?: string | null;
  REGON?: string | null;
  KRS?: string | null;
  Address?: string | null;
  Email?: string | null;
  Phone?: string | null;
  EDeliveryAddress?: string | null;
  EpuapAddress?: string | null;
  Data: IClientData[];
  ParcelsCount: number;
  FromMagistrat: boolean;
}

export const ClientFlags = {
  None: 0,
  HasEmail: 1 << 0,
  HasPhone: 1 << 1,
  HasAddress: 1 << 2,
  HasEDeliveryAddress: 1 << 3,
  HasNote: 1 << 4,
  HasContactPerson: 1 << 5,
  HasAvatar: 1 << 6,
  FromPI: 1 << 7,
  HasEpuapAddress: 1 << 8,
  HasPesel: 1 << 9,
};
